import { Checkbox } from '@zep-us/zus';
import { cn } from '@/utils/tailwind.util';
import { type QuizBankFilterOption } from '../types';
import { QuizBankStandardTooltip } from './QuizBankStandardCode';
interface QuizBankFilterOptionRowProps {
  option: QuizBankFilterOption;
  /** 우측 문항 수. 단원에만 붙인다 (Figma) */
  showCount?: boolean;
  onToggle: (id: string) => void;
}

/**
 * 체크박스 옵션 한 줄. 0건이면 비활성으로 남기되 이미 선택된 옵션은 해제할 수 있게 둔다.
 * `description` 이 있으면(성취기준) hover 툴팁과 접근 이름에 싣는다.
 */
export const QuizBankFilterOptionRow = ({
  option,
  showCount = false,
  onToggle
}: QuizBankFilterOptionRowProps) => {
  const disabled = option.count === 0 && !option.checked;
  const label = <span className={cn('min-w-0 flex-1 truncate text-body-md-medium', option.description && 'underline decoration-dotted underline-offset-4')}>
      {option.label}
    </span>;
  return <label className={cn('flex items-center gap-xs rounded-xs px-2xs py-3xs', disabled ? 'cursor-not-allowed text-disabled' : 'cursor-pointer text-default hover:bg-alternative')} data-sentry-component="QuizBankFilterOptionRow" data-sentry-source-file="QuizBankFilterOptionRow.tsx">
      <Checkbox checked={option.checked} disabled={disabled} aria-label={option.description ? `${option.label} ${option.description}` : undefined} onCheckedChange={() => onToggle(option.id)} data-sentry-element="Checkbox" data-sentry-source-file="QuizBankFilterOptionRow.tsx" />

      {option.description ? <QuizBankStandardTooltip description={option.description}>
          {label}
        </QuizBankStandardTooltip> : label}

      {showCount && <span className={cn('shrink-0 text-body-sm-medium tabular-nums', disabled ? 'text-disabled' : 'text-alternative')}>
          {option.count}
        </span>}
    </label>;
};